// @flow
import localforage from 'localforage';
import { takeLatest, call } from 'redux-saga/effects';
import actionTypes from './actionTypes';
import { LOCALFORAGE_KEYS } from '../constants';

export function* saveLatestPosition(action: TrovitAction): Generator<*, *, *> {
  return yield call([localforage, localforage.setItem], LOCALFORAGE_KEYS.latestScrollPosition, {
    x: action.payload.scrollX,
    y: action.payload.scrollY,
  });
}

export function* updateWindowScroll(): Generator<*, *, *> {
  const latestPosition = yield call(
    [localforage, localforage.getItem],
    LOCALFORAGE_KEYS.latestScrollPosition
  );

  if (latestPosition) {
    yield call([localforage, localforage.removeItem], LOCALFORAGE_KEYS.latestScrollPosition);
    window.scrollTo(latestPosition.x, latestPosition.y);
  }

  return false;
}

export default function* scrollSagas(): Generator<*, *, *> {
  yield takeLatest(actionTypes.SAVE_SCROLL_LATEST_POSITION, saveLatestPosition);
  yield takeLatest(actionTypes.UPDATE_WINDOW_SCROLL_POSITION, updateWindowScroll);
}



// WEBPACK FOOTER //
// ./app/UI/scroll/sagas.js